<template>
  <div class="tutor-box">
    <!-- modal template start-->
    <div v-if="this.start_teach">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container col-md-8">
            <div class="modal-header" style="display:block">
              <div name="header">
                <h3 class="text-center">歡迎來到Flowneat,準備開始進行您的銷售管理！</h3>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-xs-4">
                  <h4>個人使用</h4>
                  <h1><i class="fas fa-user"></i></h1>
                  <p>我是個人使用，不會有夥伴需要馬上加入</p>
                </div>
                <div class="col-xs-4">
                  <h4>建立團隊</h4>
                  <h1><i class="fas fa-wrench"></i></h1>
                  <p>我需要建立一個團隊，讓整體團隊使用，並邀請團隊成員加入</p>
                </div>
                <div class="col-xs-4">
                  <h4>加入團隊</h4>
                  <h1><i class="fas fa-users"></i></h1>
                  <p>我需要加入已經存在的團隊</p>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-4">
                  <button class="btn btn-info" @click="start_teach=false;before_startTour_modal=true;">
                    開始個人教學
                  </button>
                </div>
                <div class="col-xs-4">
                  <button class="btn btn-info" @click="startBuildTeam()">
                    開始建立團隊，邀請夥伴
                  </button>
                </div>
                <div class="col-xs-4">
                  <button class="btn btn-info" @click="startJoinTeam()">
                    如何加入夥伴的團隊
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="this.build_team_modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container col-md-8">
            <div class="modal-header" style="display:block">
              <div name="header">
                <h3 class="text-center">如何邀請新夥伴</h3>
              </div>
            </div>
            <div class="modal-body text-left">
              <ol>
                <li>請您的新夥伴註冊Flowneat，並完成信箱驗證。</li>
                <li>你可以透過『團隊管理功能』，輸入您的夥伴Email邀請他加入</li>
                <li>您的夥伴將會收到邀請Email，請夥伴點擊接收即可加入！</li>
              </ol>
            </div>
            <div class="modal-footer j-forms col-md-12">
              <div name="footer">
                <button class="btn btn-default" @click="build_team_modal=false;start_teach=true">
                  返回上一頁
                </button>
                <button class="btn btn-info" @click="build_team_modal=false;before_startTour_modal=true;">
                  下一步
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="this.join_team_modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container col-md-8">
            <div class="modal-header" style="display:block">
              <div name="header">
                <h3 class="text-center">透過以下流程，你就可以成功加入團隊</h3>
              </div>
            </div>
            <div class="modal-body text-left">
              <ol>
                <li>告訴你的邀請人你的Email「{{user.email}}」，請他邀請您，系統將會寄送邀請信，到您的信箱給您。</li>
                <li>到您的信箱，收取邀請信，點擊邀請連結，即可完成加入。</li>
                <li>加入完成後，您的相關設定將會套用新團隊的設定</li>
              </ol>
            </div>
            <div class="modal-footer j-forms col-md-12">
              <div name="footer">
                <button class="btn btn-default" @click="join_team_modal=false;start_teach=true">
                  返回上一頁
                </button>
                <button class="btn btn-info" @click="join_team_modal=false;before_startTour_modal=true;">
                  下一步
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template start-->
    <div v-if="this.before_startTour_modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container col-md-8">
            <div class="modal-header" style="display:block">
              <div name="header">
                <h3 class="text-center">我們將帶領你快速了解如何使用Flowneat</h3>
              </div>
            </div>
            <div class="modal-body">
              <h5>只要3分鐘，您就能了解如何使用Flowneat，管理交易、建立報價單、管理聯絡人、分析業務...等等重要功能。</h5>
              <div class="row">
                <div class="col-3">
                  <h1><i class="fa fa-file-invoice-dollar"></i></h1>
                  <p>交易管理</p>
                </div>
                <div class="col-3">
                  <h1><i class="fa fa-users"></i></h1>
                  <p>客戶管理</p>
                </div>
                <div class="col-3">
                  <h1><i class="fas fa-chart-line"></i></h1>
                  <p>業績管理</p>
                </div>
                <div class="col-3">
                  <h1><i class="far fa-calendar-alt"></i></h1>
                  <p>代辦事項管理</p>
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms col-md-12">
              <div name="footer">
                <button class="btn btn-info" @click="before_startTour_modal=false;startTour();">
                  開始導覽
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-tour :options="myOptions" name="myTour" :steps="personal_steps" :callbacks="personalStepCallBack"></v-tour>
    <v-tour :options="myOptions" name="buildTeamTour" :steps="build_team_steps" :callbacks="buildTeamStepCallBack"></v-tour>
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
    <!-- modal template end-->
  </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import VueTour from 'vue-tour'

export default {
  name: 'tutor_steps',
  components: {
    Simplert 
  },
  data() {
    return {
      toggle_aside: '',
      show_activity_modal: '',
      start_teach: true,
      join_team_modal: false,
      build_team_modal: false,
      before_startTour_modal: false,
      refs: this.$refs,
      myOptions:{
        labels: {
          buttonSkip: '跳過導覽',
          buttonPrevious: '上一個',
          buttonNext: '下一個',
          buttonStop: '完成導覽'
        }
      },
      build_team_steps:[
        {
          target: '.v-team-step-0-1',  // We're using document.querySelector() under the hood
          content: '「團隊管理」：點此可以管理團隊，邀情人員，以及進行各種管理。',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.v-team-step-0-3',  // We're using document.querySelector() under the hood
          content: '「新增人員」：先請新進人員，直接註冊Flowneat，並完成信箱驗證之後，您就可點擊此按鈕，輸入他的Email，系統將寄發團隊邀請連結，請新進人員前往信箱，並點擊信件中的『加入團隊』就可完成成員新增囉！',
          params: {
            placement: 'down'
          }
        },
        {
          target: '.v-team-step-0-2',  // We're using document.querySelector() under the hood
          content: '「團隊清單」：管理你的團隊成員，以及定義他們的業績，查詢業績目標狀況。',
          params: {
            placement: 'left'
          }
        },
      ],
      personal_steps: [
        {
          target: '.v-step-0-1',  // We're using document.querySelector() under the hood
          content: '「交易管理」：你目前所在的地方，擺放你所有<strong>『交易』</strong><br>你將會有大部分的時間是在此處管理你交易'
        },
        {
          target: '.v-step-0-2',
          content: '「建立交易」：你可以在此處建立一個新交易。交易就是你的報價、或是訂單、或是一個進度。',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.v-step-0-3',
          content: '「交易階段管理」：你的交易將會有多個階段，隨著你的報價、議價、同時拖曳更新交易的狀態',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.v-step-0-4',
          content: '「拖曳管理」：譬如當你報價完成之後，就可以將交易，拖曳到各個階段盒子內，已改變階段狀態，試著拖曳看看！',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-2',
          content: '「客戶管理」：你所建立的聯絡人，公司訊息，以後都可以在此處追蹤。',
        },
        {
          target: '.v-step-4',
          content: '「產品管理」：在此處建立，並查看你的商品，完整的建立你的服務項目與商品資訊是很重要的，當你的新業務加入團隊，他只要瀏覽你們的項目與說明，就能了解團隊的產品，加速上手。',
        },
        {
          target: '.v-step-4-1',
          content: '所有產品都可以拖曳改變順序，或是拖曳改變分類',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.v-step-4-2',
          content: '產品建立完成後，最重要的是，往後如果你需要建立報價單，將不須在複製貼上文字，直接可以挪用，點下一步，帶你體驗神奇的報價單產出流程',
        },
        {
          target: '.v-step-6-1',
          content: '「點擊交易第一筆交易」：現在，可以點擊第一個「範例」交易，進入交易畫面',
        },
        {
          target: '.v-step-6-2',
          content: '「建立報價單」：你可以使用報價單建立功能，建立跟此交易有關的報價，並且留存每一版本的報價單。',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.v-step-6-3',
          content: '「建立留言」：你可以針對此專案，留下各種備註或紀錄，以供未來查核使用。',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.v-step-6-4',
          content: '「建立待辦事項」：可以建立跟此專案有關的各種代辦事項，並且標注完成狀況。',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.v-step-6-5',
          content: '「上傳檔案」：可以上傳各種跟專案有關的檔案，譬如合約、紙本會議紀錄掃描黨、專案架構檔案...等等，作為專案資料留存。',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.v-step-6-6',
          content: '「交易備註」：代辦事項、留言備註、檔案..等等紀錄都會保留在此區，以供您未來搜尋使用，也可以快速了解此專案的過程。',
          params: {
            placement: 'left'
          }
        },
        {
          target: '.v-step-6-7',
          content: '「完成的待辦事項」：可以看到跟此專案有關的，而且已經完成的代辦事項，更重要的是統計的時間，就可了解在此專案上所花費的時間，是否符合預期',
          params: {
            placement: 'top'
          }
        }
      ],
      personalStepCallBack: {
        onPreviousStep: this.personalPreviousStepCallback,
        onNextStep: this.personalNextStepCallback
      },
      buildTeamStepCallBack: {
        onPreviousStep: this.buildTeamPreviousStepCallback,
        onNextStep: this.buildTeamNextStepCallback
      },
    }
  },
  props: ['user'],
  created() {

  },
  mounted: function () {
      this.personalStepCallBack.onStop = () => {
        if(this.user.is_teached==false){
          //將會員標註為已完成導覽
          const vm = this;
          this.axios.post('/users/finished_personal_tour', {
            user: {
              email: vm.user.email,
              user_token: vm.user.user_token,
            }
          })
          .then(function(response) {
            if (response['data']['status'] == 'success') {
              var obj = {
                isShown: true,
                title: '導覽結束',
                message: '你的導覽已結束、若未來還有任何使用上的疑問，請到Flowneat幫助中心，將會有更多教學與使用說明，引導你更深入業績管理的世界',
                type: 'success',
                customCloseBtnText: '開始使用Flowneat',
              }
              vm.refs.simplert.openSimplert(obj);
            }
          })
          .catch(function(error) {
            console.log('error:', error)
          });
        }
      }

      this.buildTeamStepCallBack.onStop = () => {
        this.before_startTour_modal = true
      }
    },
  methods: {
    checkTeached() {
      const vm = this
      if(this.user.is_teached==false){
        vm.$tours['myTour'].start()
      }
    },
    startTour() {
      this.$tours['myTour'].start()
    },
    startJoinTeam() {
      this.start_teach  = false
      this.join_team_modal = true
    },
    startBuildTeam() {
      this.start_teach  = false
      this.$tours['buildTeamTour'].start()
    },
    personalPreviousStepCallback (currentStep) {
      console.log('[Vue Tour] A custom previousStep callback has been called on step ' + (currentStep))
      if ([4].includes(currentStep)) {
        this.$router.push('/dashboard')
      }else if ([5].includes(currentStep)) {
        this.$router.push('/contacts')
      }else if ([6,7,8].includes(currentStep)) {
        this.$router.push('/products')
      }else if ([10,11,12,13,14,15].includes(currentStep)) {
        var a = $('#deal-wrapper-content').find('.list-group-item')
        console.log(a,a.attr('id'));
        this.$router.push('/deal/'+a.attr('id'))
      }else{
        this.$router.push('/dashboard')
      }
    },
    personalNextStepCallback (currentStep) {
      console.log('[Vue Tour] A custom nextStep callback has been called on step ' + (currentStep))
      if ([3].includes(currentStep)) {
        this.$router.push('/contacts')
      }else if ([4,5,6].includes(currentStep)) {
        this.$router.push('/products')
      }else if ([8,9,10,11,12,13].includes(currentStep)) {
        var a = $('#deal-wrapper-content').find('.list-group-item')
        console.log(a,a.attr('id'));
        this.$router.push('/deal/'+a.attr('id'))
      }else if ([14].includes(currentStep)) {
        // var a = $('#quotation_box').find('.single_quotation')
        // console.log(a,a.attr('id'));
        // this.$router.push('/quotation/'+a.attr('id'))
      }else{
        this.$router.push('/dashboard')
      }
    },
    buildTeamPreviousStepCallback (currentStep) {
      if ([1].includes(currentStep)) {
        this.$router.push('/dashboard')
      }else if ([2,3].includes(currentStep)) {
        this.$router.push('/setting/members')
      }
    },
    buildTeamNextStepCallback (currentStep) {
      if ([].includes(currentStep)) {
        this.$router.push('/dashboard')
      }else if ([0,1,2].includes(currentStep)) {
        this.$router.push('/setting/members')
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// TutorSteps.vue?0be81b04